import React, { useEffect, useState } from "react";
import {
  AppBar as MuiAppBar,
  Box,
  CssBaseline,
  Divider,
  Drawer as MuiDrawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Menu,
  MenuItem,
  Avatar,
  Typography,
  useMediaQuery,
  Collapse,
} from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import DraftsIcon from "@mui/icons-material/Drafts";
import StarIcon from "@mui/icons-material/Star";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { Link, Outlet, useNavigate } from "react-router-dom";
import ProfileMenu from "../ProfileMenu";
import apiClient from "../../utils/apiClient";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from 'react-redux';
import FallbackImage from "../FallbackImage";
import {  pageRoute, siteData } from "../../utils/common";
import BrandingWatermarkIcon from "@mui/icons-material/BrandingWatermark"
import ArticleIcon from '@mui/icons-material/Article';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
// MUI Icons
import SlideshowIcon from "@mui/icons-material/Slideshow";
import CategoryIcon from "@mui/icons-material/Category";
import ImageIcon from "@mui/icons-material/Image";
import CollectionsIcon from "@mui/icons-material/Collections";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import ListAltIcon from "@mui/icons-material/ListAlt";
import GroupIcon from "@mui/icons-material/Group"; // ✅ For User Management
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import EmailIcon from "@mui/icons-material/Email";
import RecentActorsIcon from '@mui/icons-material/RecentActors';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import SettingsIcon from '@mui/icons-material/Settings';
const drawerWidth = 240;

// ✅ Drawer styles
const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
    boxSizing: "border-box",
    ...(open && {
      ...openedMixin(theme),
      "& .MuiDrawer-paper": openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      "& .MuiDrawer-paper": closedMixin(theme),
    }),
  })
);

export default function ResponsiveMiniDrawer() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [open, setOpen] = useState(true);
  const [mobileOpen, setMobileOpen] = useState(false);

  // submenu states
  const [openInbox, setOpenInbox] = useState(false);
  const [openDrafts, setOpenDrafts] = useState(false);

  const handleDrawerOpen = () => setOpen(true);
  const handleDrawerClose = () => setOpen(false);
  const handleMobileToggle = () => setMobileOpen(!mobileOpen);
  const logo = useSelector((state) => state.logo);

  const dispatch = useDispatch()
  const getProfile = async () => {
    try {
      const res = await apiClient.get("/api/admin/get");
      dispatch({ key: 'user', value: res.data.data, type: 'SET_VALUE' })

    } catch (err) {
      if (err.response) {
        toast.error(err.response.data.message || "Somthing Wrong");
      } else {
        toast.error("Network error. Please try again.");
      }
    }
  }

  useEffect(() => {
    getProfile()
  }, [])

  const navigate = useNavigate()

  const pageChange = (url) => {
    navigate(url)
  }

  const drawerContent = (
    <>
      <DrawerHeader>
        {!isMobile && (
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "rtl" ? <ChevronRightIcon /> : <ChevronLeftIcon />}
          </IconButton>
        )}
      </DrawerHeader>
      <Divider />
      <List>
       
        {/* <ListItem disablePadding sx={{ display: "block" }} onClick={() => pageChange(pageRoute.newsLatter)}>
          <ListItemButton>
            <ListItemIcon>
              <EmailIcon />
            </ListItemIcon>
            <ListItemText primary="News Letter" sx={{ opacity: open ? 1 : 0 }} />
          </ListItemButton>
        </ListItem> */}
        <ListItem disablePadding sx={{ display: "block" }} onClick={() => pageChange(pageRoute.contactUsList)}>
          <ListItemButton>
            <ListItemIcon>
              <RecentActorsIcon />
            </ListItemIcon>
            <ListItemText primary="Contact Us List" sx={{ opacity: open ? 1 : 0 }} />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding sx={{ display: "block" }} onClick={() => pageChange('/blog')}>
          <ListItemButton>
            <ListItemIcon>
              <ArticleIcon />
            </ListItemIcon>
            <ListItemText primary="Blogs" sx={{ opacity: open ? 1 : 0 }} />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding sx={{ display: "block" }} onClick={() => pageChange(pageRoute.channelManagement)}>
          <ListItemButton>
            <ListItemIcon>
              <CategoryIcon />
            </ListItemIcon>
            <ListItemText primary="Channel Management" sx={{ opacity: open ? 1 : 0 }} />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding sx={{ display: "block" }} onClick={() => pageChange(pageRoute.sliderManagement)}>
          <ListItemButton>
            <ListItemIcon>
              <SlideshowIcon />
            </ListItemIcon>
            <ListItemText primary="Slider Management" sx={{ opacity: open ? 1 : 0 }} />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding sx={{ display: "block" }} onClick={() => pageChange(pageRoute.matchDetails)}>
          <ListItemButton>
            <ListItemIcon>
              <SportsSoccerIcon />
            </ListItemIcon>
            <ListItemText primary="Matchs" sx={{ opacity: open ? 1 : 0 }} />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding sx={{ display: "block" }} onClick={() => pageChange('/website-settings')}>
          <ListItemButton>
            <ListItemIcon>
              <SettingsIcon />
            </ListItemIcon>
            <ListItemText primary="Website Settings" sx={{ opacity: open ? 1 : 0 }} />
          </ListItemButton>
        </ListItem>
       
      </List>
    </>
  );

  return ( 
    <Box sx={{ display: "flex" }}>
      <CssBaseline />

      <AppBar position="fixed" open={open && !isMobile}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={isMobile ? handleMobileToggle : handleDrawerOpen}
            sx={{ mr: 2, ...(open && !isMobile && { display: "none" }) }}
          >
            <MenuIcon />
          </IconButton>
          <Link to={pageRoute.profile}>
            <FallbackImage
              src={'https://footplayhd.com/logo.png'}
              style={{ maxHeight: '50px' }}
            />
          </Link>
          <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1, paddingLeft: '10px' }}>
            {siteData.name}
          </Typography>
          <ProfileMenu />
        </Toolbar>
      </AppBar>


      {/* ✅ Drawer for Desktop */}
      {!isMobile && <Drawer variant="permanent" open={open}>{drawerContent}</Drawer>}

      {/* ✅ Drawer for Mobile */}
      {isMobile && (
        <MuiDrawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleMobileToggle}
          ModalProps={{ keepMounted: true }}
          sx={{
            "& .MuiDrawer-paper": { boxSizing: "border-box", width: drawerWidth },
          }}
        >
          {drawerContent}
        </MuiDrawer>
      )}

      {/* ✅ Main Content */}
      <Box component="main" sx={{ flexGrow: 1, p: 3, backgroundColor: '#ebebeb', minHeight: '100vh' }}>
        <DrawerHeader />
        <Outlet />
      </Box>
    </Box>
  );
}
